import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGraduateCap: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="graduate-cap, study, education, academic, student"><path d="M4.75081 10.9688V16.6406L12.0008 20.25L19.2508 16.6406V10.9688M23.1009 9.75V15.25M12.0008 3.75L1.80078 9L12.0008 14.25L22.2009 9L12.0008 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGraduateCap;
